import { createSelector } from 'reselect';

import { CHECKLIST_UPSELLING } from 'constants/ChecklistConstants';

import { getSelectedDealer } from 'selectors/dealerSelectors';

import { getState as getParent } from '.';

type SelectedDealer = { id?: string; groupId?: string; group?: { id?: string } };

const getState = createSelector(getParent, root => root.ui.selectExtrasIntervention);

const getPage = createSelector(getState, select => select.page);

export const getParams = createSelector(getPage, getSelectedDealer, (page, dealer: SelectedDealer = {}) => {
  const { id: dealerId, group, groupId } = dealer;
  return {
    types: CHECKLIST_UPSELLING,
    page: page.number ?? 0,
    size: page.size ?? 20,
    sort: ['dealerId,asc', 'groupId,asc', 'name,asc'],
    groupId: group?.id ?? groupId,
    dealerId,
  };
});
